import React, { useState } from 'react';
import '../../css/BdStyles.css';

const BdTags = () => {
    const tags = [
        // Ejemplo de tags
        { id: 1, name: 'Acción', description: 'Escenas de acción' },
        { id: 2, name: 'Comedia', description: 'Momentos de risa y diversión' },
        { id: 3, name: 'Drama', description: 'Historias conmovedoras' }
    ];

    const [selectedTag, setSelectedTag] = useState(null);

    const handleTagClick = (tag) => {
        setSelectedTag(tag);
        const modal = new window.bootstrap.Modal(document.getElementById('exampleModal')); // Inicializa el modal (usando Bootstrap 5)
        modal.show();
    };

    return (
        <div className="container">
            <h2 className="title">Etiquetas</h2>
            <ul className="list-group">
                {tags.map(tag => (
                    <button
                        type="button"
                        key={tag.id}
                        onClick={() => handleTagClick(tag)}
                        className="btn btn-outline-primary tag"
                    >
                        {tag.name}
                    </button>
                ))}
            </ul>

            {/* Modal */}
            <div className="modal fade" id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">{selectedTag ? selectedTag.name : 'Etiqueta'}</h5>
                            <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {selectedTag ? selectedTag.description : 'No hay descripción disponible'}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BdTags;
